import { Title, TitleProps } from "@mantine/core";
import { ReactElement } from "react";

export default function PageTitle({
  children,
  ...titleProps
}: Omit<TitleProps, "order" | "size">): ReactElement {
  return (
    <Title order={1} size="h4" {...titleProps}>
      {children}
    </Title>
  );
}
